import type { TourResolver } from '@nucleus-commerce/admin-kit/tour';
import {
  getPlatformV1Applications,
  getPlatformV1Organizations,
} from '@nucleus-commerce/api-client/platform';

/** A new application shows the review buttons; any application will do when none is new. */
export const applicationForReview: TourResolver = {
  key: 'application-for-review',
  thing: 'things.application',
  load: async () => {
    const fresh = await getPlatformV1Applications({ limit: 1, status: 'new' });
    const application = fresh.items[0] ?? (await getPlatformV1Applications({ limit: 1 })).items[0];
    return application ? { applicationId: application.id } : null;
  },
};

/** An active organisation shows every action on the page; any organisation will do otherwise. */
export const organizationForDetail: TourResolver = {
  key: 'organization-for-detail',
  thing: 'things.organization',
  load: async () => {
    const active = await getPlatformV1Organizations({ limit: 1, status: 'active' });
    const organization =
      active.items[0] ?? (await getPlatformV1Organizations({ limit: 1 })).items[0];
    return organization ? { organizationId: organization.id } : null;
  },
};
